<template>
    <div class="fixed top-4 right-4 z-[200] space-y-2 max-w-sm w-full pointer-events-none">
        <transition-group name="toast-slide">
            <div v-for="(toast, index) in toasts" :key="toast.id" :class="toastClass(toast.type)" class="pointer-events-auto flex items-start gap-3 px-4 py-3.5 rounded-xl shadow-lg shadow-gray-200/40 border text-sm backdrop-blur-sm">
                <div class="shrink-0 mt-0.5">
                    <svg v-if="toast.type === 'success'" class="w-5 h-5 text-emerald-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
                    <svg v-else-if="toast.type === 'error'" class="w-5 h-5 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4.5c-.77-.833-2.694-.833-3.464 0L3.34 16.5c-.77.833.192 2.5 1.732 2.5z"/></svg>
                    <svg v-else class="w-5 h-5 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
                </div>
                <span class="flex-1 font-medium leading-snug">{{ toast.message }}</span>
                <button @click="dismiss(index)" class="shrink-0 opacity-50 hover:opacity-100 transition-opacity cursor-pointer p-0.5 -mr-1 -mt-1">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/></svg>
                </button>
            </div>
        </transition-group>
    </div>
</template>
<script>
export default {
    data: () => ({ toasts: [], idCounter: 0 }),
    methods: {
        toastClass(type) {
            const classes = {
                success: 'bg-white/90 border-emerald-200/60 text-gray-800',
                error: 'bg-white/90 border-red-200/60 text-gray-800',
                info: 'bg-white/90 border-blue-200/60 text-gray-800',
            };
            return classes[type] || classes.info;
        },
        add(type, message) {
            const id = ++this.idCounter;
            this.toasts.push({ id, type, message });
            setTimeout(() => this.dismissById(id), 4000);
        },
        dismiss(index) { this.toasts.splice(index, 1); },
        dismissById(id) {
            const idx = this.toasts.findIndex(t => t.id === id);
            if (idx !== -1) this.toasts.splice(idx, 1);
        },
        onExternalToast(event) {
            const { type, message } = event.detail || {};
            if (!message) return;
            this.add(type || 'info', message);
        },
    },
    mounted() {
        this.$nextTick(() => {
            if (this.$page.props.flash?.success) {
                this.add('success', this.$page.props.flash.success);
            }
            if (this.$page.props.flash?.error) {
                this.add('error', this.$page.props.flash.error);
            }
            if (this.$page.props.flash?.info) {
                this.add('info', this.$page.props.flash.info);
            }
        });
        window.addEventListener('nido:toast', this.onExternalToast);
    },
    beforeUnmount() {
        window.removeEventListener('nido:toast', this.onExternalToast);
    },
    watch: {
        '$page.props.flash'(newFlash) {
            if (newFlash?.success) {
                this.add('success', newFlash.success);
            }
            if (newFlash?.error) {
                this.add('error', newFlash.error);
            }
            if (newFlash?.info) {
                this.add('info', newFlash.info);
            }
        },
    },
};
</script>
<style scoped>
.toast-slide-enter-active { transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1); }
.toast-slide-leave-active { transition: all 0.2s ease-in; }
.toast-slide-enter-from { transform: translateX(100%) scale(0.95); opacity: 0; }
.toast-slide-leave-to { transform: translateX(100%) scale(0.95); opacity: 0; }
</style>
